import React from "react";
import {
  FaUserCog,
  FaNetworkWired,
  FaPuzzlePiece,
  FaShieldAlt,
  FaExchangeAlt,
  FaCoins,
  FaDesktop,
  FaIdBadge,
  FaDatabase,
  FaHistory,
  FaGlobe,
  FaCogs,
  FaLeaf,
  FaLifeRing,
} from "react-icons/fa";

function UserControl() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Stunning Features of our Web3 Wallet
                      </h2>
                      <p>
                        Innovative solutions designed for secure asset
                        management, seamless dApp interactions, and enhanced
                        user control, ensuring a robust and user-friendly
                        experience in the decentralized ecosystem.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="">
                    <div className="container">
                      <div className="services-style-four-items">
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaUserCog size={35} />
                          </div>
                          <h4>User Control</h4>
                          <p>
                            Users retain full control over their private keys,
                            ensuring ownership and security of their assets.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaNetworkWired size={35} />
                          </div>
                          <h4>Multi-Blockchain Support</h4>
                          <p>
                            Compatibility with multiple blockchain networks,
                            allowing users to manage various cryptocurrencies
                            and tokens in one place.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaPuzzlePiece size={35} />
                          </div>
                          <h4>Seamless dApp Integration</h4>
                          <p>
                            Easy connection to decentralized applications
                            (dApps) for activities like trading, lending, and
                            gaming.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaShieldAlt size={35} />
                          </div>
                          <h4>Enhanced Security</h4>
                          <p>
                            Advanced security measures, including encryption,
                            biometric authentication, and multi-signature
                            support to protect user assets.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaExchangeAlt size={35} />
                          </div>
                          <h4>Built-in Swap Functionality</h4>
                          <p>
                            Allowing users to swap tokens directly within the
                            wallet for greater convenience.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaCoins size={35} />
                          </div>
                          <h4>Multi-Currency Support</h4>
                          <p>
                            Ability to store and manage different types of
                            cryptocurrencies and tokens, including NFTs.
                          </p>
                        </div>
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaDesktop size={35} />
                          </div>
                          <h4>User-Friendly Interface</h4>
                          <p>
                            Intuitive and accessible design for users of all
                            experience levels, from beginners to advanced
                            traders.
                          </p>
                        </div>
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaIdBadge size={35} />
                          </div>
                          <h4>KYC and AML Compliance</h4>
                          <p>
                            Integration of Know Your Customer (KYC) and
                            Anti-Money Laundering (AML) protocols to ensure
                            regulatory compliance.
                          </p>
                        </div>
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaDatabase size={35} />
                          </div>
                          <h4>Backup and Recovery Options</h4>
                          <p>
                            Secure backup features and recovery phrases to help
                            users restore access to their wallets if needed.
                          </p>
                        </div>
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaHistory size={35} />
                          </div>
                          <h4>Transaction History</h4>
                          <p>
                            Detailed transaction records and analytics for users
                            to track their assets and activities.
                          </p>
                        </div>
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaGlobe size={35} />
                          </div>
                          <h4>Cross-Platform Access</h4>
                          <p>
                            Availability on multiple platforms, including web,
                            mobile, and desktop, for easy asset management on
                            the go.
                          </p>
                        </div>
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaCogs size={35} />
                          </div>
                          <h4>Customizable Features</h4>
                          <p>
                            Options for users to customize settings, themes, and
                            notification preferences for a personalized
                            experience.
                          </p>
                        </div>
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaLeaf size={35} />
                          </div>
                          <h4>Support for Staking and Yield Farming</h4>
                          <p>
                            Features that allow users to stake their assets or
                            participate in yield farming directly from the
                            wallet.
                          </p>
                        </div>
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaLifeRing size={35} />
                          </div>
                          <h4>In-App Support and Resources</h4>
                          <p>
                            Access to customer support and educational resources
                            to help users navigate and maximize their wallet
                            experience.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserControl;
